import React from 'react'

function HelpCenter() {
  React.useEffect(() => {
    window.location.replace('https://intercom.help/mini-course-generator/en/')
  }, [])
  return <></>
}

export default HelpCenter
